import { FC, SVGProps } from 'react';

import { ReactComponent as DesignIcon } from '../../assets/icons/design-icon.svg';
import { ReactComponent as MatrixIcon } from '../../assets/icons/matrix-icon.svg';
import { ReactComponent as CrystalsIcon } from '../../assets/icons/crystals-icon.svg';
import { ReactComponent as PythagoreanSquareIcon } from '../../assets/icons/pythagorean-square-icon.svg';
import { ChartType } from '../../types/chartTypes';

interface ChartConfig {
  id: ChartType;
  label: string;
  IconComponent: FC<SVGProps<SVGSVGElement>>;
  isDisabled: boolean;
}

export const chartConfigs: ChartConfig[] = [
  {
    id: 'soulMatrixChart',
    label: 'Матрица Судьбы',
    IconComponent: MatrixIcon,
    isDisabled: false,
  },
  {
    id: 'crystalsChart',
    label: 'Кристалы',
    IconComponent: CrystalsIcon,
    isDisabled: false,
  },
  {
    id: 'pythagoreanSquareChart',
    label: 'Квадрат Пифагора',
    IconComponent: PythagoreanSquareIcon,
    isDisabled: true,
  },
  {
    id: 'humanDesignChart',
    label: 'Дизайн человека',
    IconComponent: DesignIcon,
    isDisabled: true,
  },
];
